import { makeStyles } from 'tss-react/mui';
import { teceoGrayPrimary, teceoGraySecondary } from '../../Theme';

export const useArrowScrollerStyles = makeStyles()(() => ({
  shadowRightContainer: {
    boxShadow: `-3px 0px 16px ${teceoGrayPrimary}`,
  },
  shadowLeftContainer: {
    boxShadow: `3px 0px 16px ${teceoGrayPrimary}`,
  },
  stickyContainer: {
    zIndex: 1,
    position: 'sticky',
    bottom: 0,
    borderRadius: 12,
  },
  arrow: {
    color: teceoGraySecondary,
    fontSize: 18,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  hideContainer: {
    visibility: 'hidden',
  },
}));
